<template>
  <section class="form-list">
    <div
      v-show="!schedule.store_id && isAdministrator"
      class="loading-box"
    >
      <el-form
        label-position="left"
        label-width="80px"
        class="loading-form"
      >
        <el-form-item label="所属门店">
          <v-select-store v-model="schedule.store_id" @change="handleStoreChange"/>
        </el-form-item>
      </el-form>
    </div>

    <el-form
      class="form-box"
      label-position="right"
      label-width="80px"
      ref="form"
      :model="schedule"
      :rules="rules"
    >
      <el-form-item
        label="所属门店"
        v-if="isAdministrator"
        :class="schedule.store_id ? '' : 'hidden'"
        prop="store_id"
      >
        <v-select-store v-model="schedule.store_id" @change="handleStoreChange"/>
      </el-form-item>
      <el-form-item label="有效日期" prop="dates">
        <v-date-picker-schedule v-model="schedule.dates" :store-id="schedule.store_id" class="input-schedule-name"/>
      </el-form-item>
      <el-form-item label="课表名称">
        <el-input
          v-model="schedule.schedule_name"
          class="input-schedule-name"
          clearable
          maxlength="250"
        />
      </el-form-item>
    </el-form>

    <div id="timetable">
      <div class="timetable-header">
        <div v-for="v in weeks" :key="v" class="timetable-title">{{v}}</div>
        <div @click="handleAddRow(0)" class="timetable-first-add-icon-box primary-color">
          <v-icon name="add"/>
        </div>
      </div>
      <div class="timetable-body">
        <div v-for="(v, dayNumber) in courses" :key="dayNumber" class="timetable-body-column">
          <div
            v-for="index in maxRowNumber"
            :key="index"
            @click="openAddCourseDialog(index - 1, dayNumber)"
            class="timetable-body-item"
          >
            <template v-if="(v[index - 1] || {}).teachers">
              <div class="timetable-course-item">
                <div class="timetable-body-duration">
                  {{v[index - 1]['start_time']}} - {{v[index - 1]['end_time']}}
                </div>
                <div v-if="!isMobile" class="flex-center">
                  <el-image
                    v-for="(teacher, teacherIndex) in v[index - 1].teachers.slice(0, 2)"
                    :key="`teacher${teacherIndex}`"
                    :src="teacher.avatar"
                    :class="`timetable-body-avatar ${getAvatarClass(v[index - 1], teacherIndex)}`"
                  >
                    <div slot="placeholder" class="timetable-avatar-slot">
                      <i class="el-icon-picture-outline"/>
                    </div>
                    <div slot="error" class="timetable-avatar-slot">
                      <i class="el-icon-picture-outline"/>
                    </div>
                  </el-image>
                </div>
                <span class="timetable-body-name hover-color">{{ getNickname(v[index - 1]) }}</span>

                <template v-if="!isMobile">
                  <div class="timetable-body-name timetable-body-course">
                    {{v[index - 1].style_name}}
                    /
                    {{v[index - 1].difficulty_name}}
                    /
                    {{v[index - 1].age_name}}
                  </div>
                  <div class="timetable-body-name timetable-body-course">
                    课程人数：{{v[index - 1].student_number}}
                  </div>
                </template>
                <div v-else class="timetable-body-name timetable-body-course">{{ v[index - 1].style_name }}</div>

              </div>
              <div
                @click="openEditCourseDialog(v[index - 1])"
                class="timetable-action-box timetable-edit-box"
              >
                <v-icon name="edit"/>
              </div>
              <div
                @click.stop="deleteCourse(index - 1, dayNumber)"
                class="timetable-action-box timetable-delete-box"
              >
                <v-icon name="delete"/>
              </div>
            </template>
            <span v-else class="timetable-add-button">
              <v-icon name="add"/>
              <span class="add-title">添加课程</span>
            </span>
          </div>
        </div>
        <div class="timetable-remove-column">
          <div v-for="index in maxRowNumber" :key="index">
            <div
              v-if="maxRowNumber > 1"
              @click="removeRow(index - 1)"
              class="timetable-remove-item danger-color"
            >
              <v-icon name="remove"/>
            </div>
          </div>
        </div>

        <div class="timetable-add-column">
          <div
            class="timetable-remove-item primary-color"
            v-for="index in maxRowNumber"
            :key="index"
            @click="handleAddRow(index)"
          >
            <v-icon name="add"/>
          </div>
        </div>
      </div>
    </div>

    <div class="timetable-footer timetable-alert">
      <el-alert
        title="同步功能说明：保存课表后，若课表有效日期包含未来 7 天的任意一天（包含今天），系统将立即删除当天已上线的课程，并根据此课表重新生成当天的课程，请确认无误后再进行操作！"
        type="info"
        effect="dark"
        show-icon
        :closable="false"
      />
    </div>

    <div class="timetable-footer timetable-alert">
      <el-alert
        title="有效日期说明：课表之间有效日期不能重叠；已被其他课表占用的日期会显示为灰色且不可选择。"
        type="info"
        effect="dark"
        show-icon
        :closable="false"
      />
    </div>

    <div class="timetable-footer timetable-alert">
      <el-alert
        title="定时任务说明：保存课表后，若课表有效日期包含未来第 8 天（从今天开始计算），系统将在明天 0 点生成第 8 天的课程，例如 1 月 1 号 0 点 0 分将生成 1 月 7 号的课程，1 月 2 号生成 1 月 8 号的课程，以此类推……"
        type="info"
        effect="dark"
        show-icon
        :closable="false"
      />
    </div>

    <div class="timetable-footer">
      <el-button
        @click="handleSubmit"
        :loading="isSaving"
        type="success"
        icon="el-icon-s-promotion"
      >
        保存课表
      </el-button>
    </div>

    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="showAddCourseDialog"
      :width="`${isMobile ? '90vw' : '700px'}`"
    >
      <el-form :model="course" ref="course" :rules="courseRules">
        <el-form-item label="课程老师" prop="teachers_id" :label-width="formLabelWidth">
          <v-select-teacher
            v-model="course.teachers_id"
            :multiple="true"
            :store-id="schedule.store_id"
            :remote="true"
            @change="handleTeacherChange"
          />
        </el-form-item>
        <el-form-item label="舞蹈风格" :label-width="formLabelWidth" prop="course_style_id">
          <v-select-course-style
            v-model="course.course_style_id"
            @change="handleCourseStyleChange"
          />
        </el-form-item>
        <el-form-item label="课程难度" :label-width="formLabelWidth" prop="course_difficulty_id">
          <v-select-course-difficulty
            v-model="course.course_difficulty_id"
            @change="handleCourseDifficultyChange"
          />
        </el-form-item>
        <el-form-item label="课程年龄" :label-width="formLabelWidth" prop="course_age_id">
          <v-select-course-age
            v-model="course.course_age_id"
            @change="handleCourseAgeChange"
          />
        </el-form-item>
        <el-form-item label="课程类型" :label-width="formLabelWidth" prop="card_type_id">
          <v-select-card-type-id
            v-model="course.card_type_id"
            :store-id="schedule.store_id"
          />
        </el-form-item>
        <el-form-item label="课程封面" :label-width="formLabelWidth" prop="course_cover_id">
          <v-select-course-cover v-model="course.course_cover_id"/>
        </el-form-item>
        <el-form-item label="课程视频" :label-width="formLabelWidth" prop="course_video_id">
          <v-select-course-video v-model="course.course_video_id"/>
        </el-form-item>
        <el-form-item label="课程标签" :label-width="formLabelWidth" prop="course_tag_ids">
          <v-select-course-tag v-model="course.course_tag_ids"/>
        </el-form-item>
        <el-form-item label="课程白名单" :label-width="formLabelWidth" prop="course_whitelist_id">
          <v-select-course-whitelist v-model="course.course_whitelist_id" :clearable="true"/>
        </el-form-item>
        <el-form-item label="注意事项" :label-width="formLabelWidth" prop="course_tip_id">
          <v-select-course-tip v-model="course.course_tip_id"/>
        </el-form-item>
        <el-form-item label="课程人数" :label-width="formLabelWidth" prop="student_number">
          <el-input
            type="number"
            min="1"
            max="255"
            v-model.number="course.student_number"
            placeholder="请输入课程人数"
            style="width: 217px"
          >
            <template v-slot:append>人</template>
          </el-input>
        </el-form-item>
        <el-form-item label="扣卡次数" :label-width="formLabelWidth" prop="decrement_number">
          <el-input
            type="number"
            min="1"
            max="999"
            v-model.number="course.decrement_number"
            placeholder="请输入课程扣卡次数"
            style="width: 217px"
          >
            <template v-slot:append>次</template>
          </el-input>
        </el-form-item>
        <el-form-item label="通卡扣卡天数" :label-width="formLabelWidth">
          <v-input-money
              :min="0"
              :max="36600"
              v-model="course.decrement_days"
              placeholder="请输入通卡预约所扣天数"
              :is-show-suffix="true"
              suffix-name="天"
              style="width: 217px"
          />
        </el-form-item>
        <el-form-item class="form-last-item" label="课程时间" :label-width="formLabelWidth" required>
          <el-time-picker
              arrow-control
              :clearable="false"
              v-model="course.start_time"
              format="HH:mm"
              value-format="HH:mm"
              @change="handleStartTimeChanged"
              placeholder="开始时间"
          />
          &nbsp;至&nbsp;
          <el-time-picker
              arrow-control
              :clearable="false"
              format="HH:mm"
              value-format="HH:mm"
              v-model="course.end_time"
              :picker-options="endTimePickerOption"
              placeholder="结束时间"
          />
        </el-form-item>

        <el-form-item label="禁止通卡预约" :label-width="formLabelWidth">
          <el-switch v-model="course.is_disable_term" :active-value="1" :inactive-value="0"/>

          <el-alert
              title="此功能默认关闭，开启后可禁止学员使用通卡预约"
              type="info"
              show-icon
              :closable="false"
          />
        </el-form-item>

        <el-form-item label="禁止课次券预约" :label-width="formLabelWidth">
          <el-switch v-model="course.is_disable_ticket" :active-value="1" :inactive-value="0"/>

          <el-alert
            title="此功能默认关闭，开启后可禁止学员使用课次券预约"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item label="可微信支付预约" :label-width="formLabelWidth">
          <el-switch v-model="course.is_we_chat_pay" :active-value="1" :inactive-value="0"/>

          <el-alert
            title="此功能默认关闭，开启后可使用微信支付进行预约课程"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item v-if="course.is_we_chat_pay" label="课程价格" prop="price" :label-width="formLabelWidth">
          <v-input-money
            class="w100"
            placeholder="请输入课程价格"
            v-model="course.price"
            :is-show-suffix="true"
            @input="handlePriceChange"
            style="width: 217px"
            :min="199"
            :max="9999.99"
          />
          <el-alert
            title="目前单节课默认最低 199 元，可设置 ≥ 199 的单节课价格"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

        <el-form-item v-if="course.is_we_chat_pay && course.is_disable_term" label="通卡价格" prop="term_price" :label-width="formLabelWidth">
          <v-input-money
            class="w100"
            placeholder="请输入通卡会员购买课程的价格"
            v-model="course.term_price"
            :is-show-suffix="true"
            style="width: 217px"
            :min="199"
            :max="course.price"
          />
          <el-alert
            title="目前单节课默认最低200元，可设置≥200的单节课价格"
            type="info"
            show-icon
            :closable="false"
          />
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddCourseDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveCourse">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { show, store } from '@/api/course-schedule';
import { toCent, toMillisecond, toSecond, toYuan } from "@/filters";

const validateStudentNumber = (rule, value, callback) => {
  callback(value < 1 || value > 255 ? new Error('课程人数必须在 1 ~ 255 人之内') : undefined);
};

// 课表会批量生成课程：扣卡次数必须 ≥ 0.01 次，0 会批量生成出一堆免费课
const validateDecrementNumber = (rule, value, callback) => {
  callback(value >= 0.01 && value <= 999 ? undefined : new Error('扣卡次数必须在 0.01 ~ 999 次之间'));
};

export default {
  name: RouteConfig.courseScheduleAdd.name,
  data() {
    return {
      isSaving: false,
      isHandleStoreChanging: false,
      showAddCourseDialog: false,
      maxRowNumber: 5,
      currentRowNumber: 0,
      currentDayNumber: 0,
      schedule: {
        store_id: '',
        schedule_name: '',
        dates: [],
      },
      formLabelWidth: '120px',
      dialogTitle: '',
      courses: [[], [], [], [], [], [], []],
      weeks: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      course: {
        row_number: 0,
        day_number: 0,
        student_number: 30,
        course_style_id: '',
        course_difficulty_id: '',
        course_age_id: '',
        card_type_id: '',
        course_cover_id: 1,
        course_video_id: 0,
        course_tip_id: 1,
        course_whitelist_id: 0,
        start_time: '13:00',
        end_time: '14:00',
        course_tag_ids: [],
        teachers_id: [],
        decrement_number: 1,
        decrement_days: 0,
        is_disable_term: 0,
        is_disable_ticket: 0,
        is_we_chat_pay: 1,
        price: 200,
        term_price: 200,
      },
      courseRules: {
        teachers_id: [{ required: true, message: '请选择老师', trigger: 'change' }],
        course_style_id: [{ required: true, message: '请选择舞蹈风格', trigger: 'change' }],
        course_difficulty_id: [{ required: true, message: '请选择课程难度', trigger: 'change' }],
        course_age_id: [{ required: true, message: '请选择课程年龄', trigger: 'change' }],
        card_type_id: [{ required: true, message: '请选择课程类型', trigger: 'change' }],
        course_cover_id: [{ required: true, message: '请选择课程封面', trigger: 'change' }],
        course_tip_id: [{ required: true, message: '请选择课程介绍', trigger: 'change' }],
        student_number: [{ required: true, validator: validateStudentNumber, trigger: 'change' }],
        start_time: [{ required: true, message: '请选择课程开始时间', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择课程结束时间', trigger: 'change' }],
        decrement_number: [{ required: true, validator: validateDecrementNumber, trigger: 'change' }],
        price: [{ required: true, message: '请选择输入课程价格', trigger: 'change' }],
        term_price: [{ required: true, message: '请选择输入通卡会员购买课程的价格', trigger: 'change' }],
      },
      rules: {
        store_id: [{ required: true, message: '请选择门店', trigger: 'change' }],
        dates: [{ required: true, message: '请选择日期范围', trigger: 'change' }],
      },
    };
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'isManagerOrReceptionist',
      'userStoreId',
    ]),
    endTimePickerOption() {
      const startTime = this.course.start_time || '00:00';
      return {
        selectableRange: `${startTime}:00-23:59:00`,
        format: 'HH:mm',
      };
    },
    id() {
      return +this.$route.query.id || 0;
    },
  },
  mounted() {
    this.schedule.store_id = this.isAdministrator ? 1 : this.userStoreId;
    this.show();
  },
  methods: {
    getAvatarClass(course, teacherIndex) {
      return course.teachers.length > 1 ? `teacher-avatar-translate-${teacherIndex}` : '';
    },
    getNickname: (course) => course.teachers.map(teacher => teacher.nickname).join(' / '),
    handlePriceChange(price) {
      this.course.term_price = price;
    },
    handleTeacherChange(teachers) {
      this.course.teachers = teachers;
    },
    handleCourseStyleChange(style_name) {
      this.course.style_name = style_name;
    },
    handleCourseDifficultyChange(difficulty_name) {
      this.course.difficulty_name = difficulty_name;
    },
    handleCourseAgeChange(age_name) {
      this.course.age_name = age_name;
    },
    openAddCourseDialog(rowNumber, dayNumber) {
      this.currentRowNumber = rowNumber;
      this.currentDayNumber = dayNumber;
      this.showAddCourseDialog = true;
      this.dialogTitle = `设置${this.weeks[dayNumber]}第 ${rowNumber + 1} 节课`;
    },
    openEditCourseDialog(course) {
      this.course = { ...course };
      this.showAddCourseDialog = true;
    },
    handleStartTimeChanged(v) {
      if (this.course.end_time > v || !v) return;

      const startTimes = v.split(':');
      let maxTime = `${+startTimes[0] + 1}:${startTimes[1]}`;
      if (maxTime > '23:59') maxTime = '23:59';
      this.course.end_time = maxTime;
    },
    saveCourse() {
      this.$refs.course.validate((valid) => {
        if (!valid) return;

        this.showAddCourseDialog = false;
        const course = { ...this.course };
        course.row_number = this.currentRowNumber;
        course.day_number = this.currentDayNumber;
        this.courses[this.currentDayNumber][this.currentRowNumber] = course;
      });
    },
    deleteCourse(rowNumber, dayNumber) {
      this.$confirm(`确认删除${this.weeks[dayNumber]}第 ${rowNumber + 1} 节课吗？`)
        .then(() => this.courses[dayNumber].splice(rowNumber, 1, {}))
        .catch(() => {});
    },
    handleStoreChange() {
      if (this.schedule.dates.length) this.schedule.dates = [];
      if (this.course.teachers_id.length) this.course.teachers_id = [];
      this.courses.forEach((v) => v.splice(0, v.length));
    },
    handleAddRow(rowNumber) {
      this.courses.forEach((v) => {
        v.splice(rowNumber, 0, {});
        v.forEach((course) => {
          if (course.row_number >= rowNumber) course.row_number += 1;
        });
      });
      this.maxRowNumber += 1;
    },
    handleRemoveRow(rowNumber) {
      this.courses.forEach((v) => {
        v.splice(rowNumber, 1);
        v.forEach((course) => {
          if (course.row_number > rowNumber) course.row_number -= 1;
        });
      });
      this.maxRowNumber -= 1;
    },
    async removeRow(rowNumber) {
      const isEmpty = !this.courses.some((course) => course[rowNumber] && course[rowNumber].start_time);
      if (isEmpty) {
        this.handleRemoveRow(rowNumber);
        return;
      }

      const confirm = await this.$confirm('此操作将删除该行所有课程, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => false);
      if (!confirm) return;

      this.handleRemoveRow(rowNumber);
    },
    async show() {
      if (!this.id || this.isLoading || this.isSaving) return;

      this.isLoading = true;
      this.isLoadingError = false;
      const { isError, data } = await show(this.id);
      this.isLoading = false;

      if (isError) {
        this.isLoadingError = true;
        return;
      }

      const { schedule } = this;
      schedule.schedule_name = data.schedule_name;
      schedule.store_id = data.store_id;
      schedule.release_state = data.release_state;
      schedule.dates = [toMillisecond(data.start_date), toMillisecond(data.end_date)];

      let maxRowNumber = 0;
      data.courses.forEach((v) => {
        v.decrement_number = toYuan(v.decrement_number);
        v.decrement_days = toYuan(v.decrement_days);
        v.price = v.price ? toYuan(v.price) : 200;
        v.term_price = v.term_price ? toYuan(v.term_price) : 200;
        this.courses[v.day_number][v.row_number] = v;
        if (v.row_number > maxRowNumber) maxRowNumber = v.row_number;
      });
      this.maxRowNumber = maxRowNumber + 1;
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const courses = [];
        this.courses.flat().forEach((v) => {
          if (!v.teachers) return;

          courses.push({
            row_number: v.row_number,
            day_number: v.day_number,
            student_number: v.student_number,
            course_style_id: v.course_style_id,
            course_difficulty_id: v.course_difficulty_id,
            course_age_id: v.course_age_id,
            card_type_id: v.card_type_id,
            course_cover_id: v.course_cover_id,
            course_video_id: v.course_video_id,
            course_tag_ids: v.course_tag_ids,
            course_tip_id: v.course_tip_id,
            course_whitelist_id: v.course_whitelist_id,
            start_time: v.start_time,
            end_time: v.end_time,
            teachers_id: v.teachers_id,
            teacher_names: v.teachers.map(teacher => teacher.nickname).join('、'),
            teacher_avatar: v.teachers[0].avatar,
            course_name: `${v.style_name} · ${v.difficulty_name}`,
            decrement_number: toCent(v.decrement_number),
            decrement_days: toCent(v.decrement_days),
            is_disable_term: v.is_disable_term,
            is_disable_ticket: v.is_disable_ticket,
            is_we_chat_pay: v.is_we_chat_pay,
            price: toCent(v.price),
            term_price: toCent(v.term_price),
          });
        });

        if (courses.length < 1) {
          this.$message.error('请设置课程后再进行提交！');
          return;
        }

        this.isSaving = true;
        const { isError } = await store({
          store_id: this.schedule.store_id,
          start_date: toSecond(this.schedule.dates[0]),
          end_date: toSecond(this.schedule.dates[1]),
          schedule_name: this.schedule.schedule_name,
          courses,
        });
        this.isSaving = false;
        if (isError) return;

        RouteConfig.courseScheduleList.push();
      });
    },
  },
};
</script>

<style src="./index.css" scoped/>
<style src="./index-phone.css" scoped/>
<style src="./loading-box.css" scoped/>
